// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"styles_checkboxContainer__bz3yK","checkbox":"styles_checkbox__IIbzZ","checkmark":"styles_checkmark__h6JRd","labelText":"styles_labelText__kJAyE"};